import { MembershipType, UserMemberSubscriptionStatus } from "@gymflow/types";
import moment from "moment-timezone";

import {
  PARAMETER_DATE_FORMAT,
  PARAMETER_DATE_FORMAT_WITHOUT_TZ,
} from "../eventApi";
import ServiceType from "../ServiceType";
import SubscriptionStatus from "../SubscriptionStatus";

const isPendingCancellation = (
  type: MembershipType,
  cancellationDate: string | undefined,
) =>
  type === ServiceType.Recurring &&
  moment(cancellationDate, PARAMETER_DATE_FORMAT).isAfter(moment());

const isPendingPause = (
  status: UserMemberSubscriptionStatus,
  pauseStartDate: string | undefined,
) => status === SubscriptionStatus.Active && pauseStartDate;

const isPausable = (
  type: MembershipType,
  cancellationDate: string | undefined,
  status: UserMemberSubscriptionStatus,
  pauseStartDate: string | undefined,
) =>
  type === ServiceType.Recurring &&
  status === SubscriptionStatus.Active &&
  !isPendingPause(status, pauseStartDate) &&
  !isPendingCancellation(type, cancellationDate);

const validateMemberBook = (startDate: string) => {
  const isBefore = moment().isBefore(
    moment(startDate, PARAMETER_DATE_FORMAT_WITHOUT_TZ),
  );
  if (isBefore) {
    return null;
  }
  return "You cannot book into events that have already started.";
};

const membershipLimits = {
  isPendingCancellation,
  isPendingPause,
  isPausable,
  validateMemberBook,
};

export default membershipLimits;
